import { render } from "./A105080.vue?vue&type=template&id=643f066a&scoped=true"
import script from "./A105080.vue?vue&type=script&lang=js"
export * from "./A105080.vue?vue&type=script&lang=js"

import "./A105080.vue?vue&type=style&index=0&id=643f066a&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-643f066a"]])

export default __exports__